/**
 * 网络请求
 **/
import { response } from './jake-data'
import { handleCityList,letterCompare,handleProvinces } from './_tool'
import api from '../../api'

export const getProvinceList = () => {
  return api.getProvinceList().then(res => {
    return handleProvinces(res.data || [])
  })
}

export const getCities = (province) => {
  return api.getCities(province).then(res => {
    return res.data || []
  })
}

export const getCityList = () => {
  return api.getCityList().then(res => {
    const list = res.data || []
    const cityListObj = handleCityList(list)
    const { regionList,defaultRegion } = cityListObj
    regionList.sort(letterCompare('name'))
    for (let i = 0; i < regionList.length; i++) regionList[i].cities.sort(letterCompare('code'))
    return {
      defaultRegion,
      regionList
    }
  })
}